// packages/shared/src/geom.ts
import type { Rot } from '@whiskerton/content';
import type { Rect, TileXY, Vec2 } from './types/geom';
export const dist = (a: Vec2, b: Vec2): number => Math.hypot(a.x - b.x, a.y - b.y);
export const tileOf = (p: Vec2): TileXY => ({ x: Math.floor(p.x), y: Math.floor(p.y) });
export const inRect = (r: Rect, x: number, y: number): boolean => x >= r.x && x < r.x + r.w && y >= r.y && y < r.y + r.h;
export const rectsOverlap = (a: Rect, b: Rect): boolean => a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h;
export function rotateFootprint(fp: readonly [number, number], rot: Rot): { w: number; d: number } {
  return rot % 2 === 0 ? { w: fp[0], d: fp[1] } : { w: fp[1], d: fp[0] };
}
export function footprintRect(x: number, y: number, fp: readonly [number, number], rot: Rot): Rect {
  const { w, d } = rotateFootprint(fp, rot);
  return { x, y, w, h: d };
}
export const clamp = (v: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, v));
